
import { PasswordChangeForm } from "./security/PasswordChangeForm";
import { SecurityQuestionsForm } from "./security/SecurityQuestionsForm";
import { useTranslation } from "@/hooks/useTranslation";

interface SecurityTabProps {
  isMobile: boolean;
}

export function SecurityTab({ isMobile }: SecurityTabProps) {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <PasswordChangeForm isMobile={isMobile} />
      <SecurityQuestionsForm isMobile={isMobile} />
    </div>
  );
}
